import React from 'react';
import {isDateField, formatDateCell} from '../../utils/dateFormat';
import Body from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import {Typography} from '@mui/material';
import {Link} from 'react-router-dom';
import BooleanCell, {isBooleanIconField} from './BooleanCell';

// A click that ends a text selection is a copy, not a navigation.
export const hasTextSelection = () =>
  (window.getSelection?.()?.toString() ?? '') !== '';

// Fills the cell so the whole row is a real link: right-click -> "Open in new tab",
// cmd/ctrl-click works, and text can still be selected and copied.
const cellLinkStyle = {
  display: 'block',
  color: 'inherit',
  textDecoration: 'none',
  userSelect: 'text',
  WebkitUserDrag: 'none',
};

const TableBody = ({
  data,
  dataCells,
  onRowClick,
  rowHref,
  getObject,
  onAddReport,
  onViewReport,
  handleSendEmail,
}) => {
  const _renderRows = () =>
    data?.map((row, index) => {
      const cellsData = Object.fromEntries(
        dataCells?.map(cell => [cell, row[cell]]),
      );
      const _renderCells = () =>
        Object.entries(cellsData)?.map((cell, cellIndex) => {

          if (cell[0] === 'viewAction') {
            return (
              <TableCell key={cellIndex}>
                <Typography sx={{textDecoration: 'underline'}} color="primary">
                  View PDF
                </Typography>
              </TableCell>
            );
          }

          if (cell[0] === 'sendAction') {
            // Add the "Send by Email" button here
            return (
              <TableCell key={cellIndex}>
                <button
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent row click
                    handleSendEmail(row); 
                  }}
                  style={{marginRight: '10px'}}>
                  <Typography
                    sx={{textDecoration: 'underline'}}
                    color="primary">
                    Send By Mail
                  </Typography>
                </button>
              </TableCell>
            );
          }

          if (cell[0] === 'addAction') {
            return (
              <TableCell key={cellIndex}>
                <button
                  onClick={e => {
                    e.stopPropagation(); // Prevent row click
                    onAddReport(row.id); // Pass row ID for adding a report
                  }}
                  style={{marginRight: '10px'}}>
                  <Typography
                    sx={{textDecoration: 'underline'}}
                    color="primary">
                    Add Report
                  </Typography>
                </button>
              </TableCell>
            );
          }

          if (cell[0] === 'viewReport') {
            return (
              <TableCell key={cellIndex}>
                <button
                  onClick={e => {
                    e.stopPropagation(); 
                    onViewReport(row.id);
                  }}>
                  <Typography
                    sx={{textDecoration: 'underline'}}
                    color="primary">
                    View Report
                  </Typography>
                </button>
              </TableCell>
            );
          }
          const content = isBooleanIconField(cell[0]) ? (
            <BooleanCell value={cell[1]} />
          ) : isDateField(cell[0]) ? (
            formatDateCell(cell[0], cell[1])
          ) : (
            cell[1]
          );
          return (
            <TableCell key={cellIndex}>
              {href ? (
                <Link
                  to={href}
                  draggable={false}
                  style={cellLinkStyle}
                  onClick={e => {
                    e.stopPropagation();
                    if (hasTextSelection()) e.preventDefault();
                  }}>
                  {content}
                </Link>
              ) : (
                content
              )}
            </TableCell>
          );
        });
      const rowArg = getObject ? row : row.id;
      const href = rowHref ? rowHref(rowArg) : null;
      return (
        <TableRow
          onClick={() => {
            if (hasTextSelection()) return;
            onRowClick?.(rowArg);
          }}
          hover
          tabIndex={index}
          key={index}
          sx={{
            cursor: 'pointer',
            backgroundColor: (index + 1) % 2 === 0 ? 'tertiary50' : 'white',
          }}>
          {_renderCells()}
        </TableRow>
      );
    });

  return <Body>{_renderRows()}</Body>;
};

export default TableBody;
